import Vue from 'vue';
import { getTrans } from 'tools/getFromHtml';

export default Vue.component('SelectSearchDatabase', {
    props: {
        disabled: {
            type: Boolean,
            required: false,
        },
        inputRole: {
            type: String,
            required: true,
        },
        inputData: {
            type: Array,
            required: true,
        },
        selectedKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            active: '',
        };
    },
    computed: {
        translated() {
            const translatedTemp = [];
            for (const p in this.inputData) {
                translatedTemp[p] = this.trans(this.inputData[p].label);
            }

            return translatedTemp;
        },
    },
    watch: {
        selectedKey(newValue) {
            let searchUri = document.querySelector('[data-path-name="search"]').dataset.path;
            searchUri = searchUri.replace(/language=\d/i, `language=${ newValue }`);
            document.querySelector('[data-path-name="search"]').dataset.path = searchUri;
        },
    },
    methods: {
        changeInput(event) {
            this.$parent.selectedLanguage = event.currentTarget.value;
        },
        trans(text) {
            return getTrans(text) ? getTrans(text) : text;
        },
    },
    template: `
        <div class="flex--grow">
            <select v-if="inputRole == 'master'" id="language" name="language" class="margin-left-10" :value="selectedKey" @change="changeInput" :disabled="disabled">
                <option v-for="(item, key) in inputData" :value="item.value" :selected="selectedKey == item.value ? 'selected' : ''">{{translated[key]}}</option>
            </select>
            <div v-if="inputRole == 'slave'" id="languageMobile" class="mobileRadioGroup mobileRadioGroup--fullWidth margin-bottom-20">
                <label v-for="(item, key) in inputData" class="mobileRadioGroup__item" >
                    <input type="radio" :value="item.value" name="languageMobile" :data-gtm_SearchDataBase="key+'-mobileDatabaseFilter'" class="mobileRadioGroup__input" :checked="selectedKey == item.value ? 'checked' : ''" @change="changeInput" :disabled="disabled">
                    <span class="mobileRadioGroup__text padding-vertical-7">{{translated[key]}}</span>
                </label>
            </div>
        </div>
    `,
});
